module.exports = __webpack_public_path__ + "img/discover@2x.5acb81c7.png";